// src/components/profile/ProfilePage.jsx

import React from 'react';
import {
  Box,
  Button,
  Grid,
  Typography,
} from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

import ProfileHero from './ProfileHero';
import ProfileSection from './ProfileSection';
import ProfileField from './ProfileField';
import StatusBadge from './StatusBadge';
import TagChip from './TagChip';
import StatCard from './StatCard';

import {
  sectionIcons,
} from './profileData';

import {
  useProfileStyles,
} from './profileStyles';
import { UserIdeaList } from 'pagesNewUi/profile/components/UserIdeaList';

const ProfilePage = (props) => {


  const {
    InnovateUserIdeasList = {},
    benchProfileResponse:profile = {},
    userProfileData = {},
    onEditProfile = ()=>{},
    onEditMyProfile = ()=>{},
    handleAddToTeam = ()=>{},
    isEnableEditProfileButton
    }= props || {}

  const classes = useProfileStyles();

  return (
    <Box className={classes.page}>
      <Grid className={classes.profileGrid} spacing={3}>
        {/* Hero Section */}
        <Grid className={classes.profileHeaderGrid} item xs={12}>
          
            <ProfileHero
              profileImage={profile.avatar}
              fullName={profile.name}
              email={profile.email}
              jobTitle={profile.jobTitle || 'Job Title'}
              company={ profile.company || "Company"}
              country={ profile.country || "Country"}
              division={ profile.division || "division"}
              // recruiterAvailable={profile.available }
              recruiterAvailable={profile.available }
              onAddToTeam={handleAddToTeam}
              // onEditPhoto={() => console.log("Edit Photo")}
              onEditPhoto={onEditMyProfile}
              profile={profile}
              onEdit={onEditProfile}
              isEnableEditProfileButton={isEnableEditProfileButton}
              
            />

        </Grid>

        {/* About */}
        <Grid item xs={12} >
          <ProfileSection
            title="About"
            icon={sectionIcons.about}  
          >
            {profile.aboutFields.map((field) => (
              <ProfileField
                key={field.label}
                label={field.label}
                value={field.value}
                icon={field.icon}
              />
            ))}
          </ProfileSection>
        </Grid>

         {/* Expertise and Interests */}
        <Grid item xs={12}>
         <ProfileSection
           title="Skills in Order of Strength"
           icon={sectionIcons.skills}
          >
            {profile.interests?.map((item) => (
             <TagChip
                key={item.label}
                label={item.label}
                color={item.color}
              />
            ))}
          </ProfileSection>
        </Grid>

        {/* Skills */}
        <Grid item xs={12} >
          <ProfileSection
            title="Ideal Team Role"
            icon={sectionIcons.skills}
          >

            {profile.idealTeamRole?.map((item) => (
             <TagChip
                key={item.label}
                label={item.label}
                color={item.color}
              />
            ))}
            
          </ProfileSection>
        </Grid>

        {/* Innovation Impact */}
        {/* <Grid item xs={12} >
          <ProfileSection
          title="Innovation Impact"
         icon={sectionIcons.interests}
          >
            <Grid Container spacing={2}>
             {profile.impactStats.map((stat) => (
                <Grid item  sm={4} md={2} key={stat.label}>
                 <StatCard
                   value={stat.value}
                   label={stat.label}
                    icon={stat.icon}
                    color={stat.color}
                  />
                </Grid>
              ))}
            </Grid>

            <Button
              fullWidth
              className={classes.viewActivityButton}
              endIcon={<ArrowForwardIcon />}
              onClick={handleViewActivity}
            >
              View My Activity
            </Button>
          </ProfileSection>
        </Grid> */}

       

        {/* Availability */}
        <Grid className={classes.profileFullRowGrid} item xs={12} >
          <ProfileSection
           title="Availability"
           icon={sectionIcons.availability}
          >
            <Box mb={3}>
              <StatusBadge
               label={
                 profile.available
                   ? 'Available to be recruited'
                    : 'Not available'
                }
                variant={profile.available ? 'success' : 'dark'}
              />
            </Box>

            

          </ProfileSection>
        </Grid>

        {/* Professional Bio */}
        <Grid className={classes.profileFullRowGrid} item xs={12} >
          <ProfileSection
            title="Professional Bio"
            icon={sectionIcons.bio}
          >
            <Typography className={classes.bioText}>
              {profile.bio}
            </Typography>
          </ProfileSection>
        </Grid>

      </Grid>

        <Grid className={classes.profileFullRowGrid} item xs={12} >
          <ProfileSection
            title={`Idea posted by ${profile.name}`}
            icon={sectionIcons.skills}
          >
            
            <UserIdeaList ideasLists={InnovateUserIdeasList}  classes={classes} />
      
      </ProfileSection>
      </Grid>


    </Box>
  );
};

export default ProfilePage;